module.exports = __webpack_public_path__ + "static/media/blue-thumb-down.79978e8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/blue-thumb-down.svg
// module id = 3231
// module chunks = 0